import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { HintField, InputField, LabelField, MyCheckbox, SelectField } from "components";
import InfoTooltip from "components/InfoTooltip";
import { MenuMultiCheckBox } from 'components/MenuMultiCheckBox/MenuMultiCheckBox';
import { useSearch } from "hook";
import React, { useState } from 'react';
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import Select, { components } from "react-select";
import { TagField } from '../TagField';
import { Label, TextAreaMessage } from './Theme';



export const TaxReport = ({ formik, accountCategoryOptions, billingTypeOptions, ledgers, isLedgerLoading, accountTags, accountTagsLoading, contactTags, contactTagsLoading, accountTypeOptions }) => {
    const [search, setSearch] = useState("");
    const { searchAction } = useSearch({ action: setSearch });
    const [loading, setLoading] = useState(false);
    const [valueCheck, setCheckValue] = useState(false);
    const [year, setYear] = useState(new Date());


    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <BottomArrowSvg label="Emoji" />
            </components.DropdownIndicator>
        );
    };
    const formatOptionLabel = ({ label, _id }) => {
        return (
            <div className="dropdown-container" key={_id}>
                <div className="icon-name-container d-flex align-items-center justify-content-start">
                    <div className="name-container" style={{ marginInlineStart: 10 }}>
                        <div>{formik.values.tax_report?.filter?.account_type && label}</div>
                    </div>
                </div>
            </div>
        );
    };

    const selectControlStyles = {
        backgroundColor: "#FFFFFF",
        border: "1px solid #ebedf3",
        color: "#3F4254",
        transition:
            "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
        paddingTop: "6px",
        paddingBottom: "6px",
        cursor: "pointer",
    };
    const colourStyles = {
        control: (styles) => ({
            ...styles,
            ...selectControlStyles,
        }),
        menuList: (styles) => ({
            ...styles,
            maxHeight: "150px",
        }),
    };
    const handleYear = (date) => {
        setYear(date)
        if (date) {
            formik.setFieldValue("tax_report.start", `${date?.getFullYear()}-01-01`);
            formik.setFieldValue("tax_report.end", `${date?.getFullYear()}-12-31`);
        } else {
            formik.setFieldValue("tax_report.start", null);
            formik.setFieldValue("tax_report.end", null);
        }

    }

    return (
        <>
            <Row className="form-row sm-12 mb-4">
                <Col className="col-12 col-md-12">
                    <div className="form-group">
                        <InputField
                            mandatory
                            type="text"
                            {...{
                                formik,
                                title: "Batch Name",
                                name: `tax_report.batchName`,
                                placeholder: "Batch Name",
                                checkValidation: true,
                                value: formik.values?.tax_report?.batchName,
                            }}
                            style={{ backgroundColor: "#FFFFFF", borderColor: "#ebedf3" }}

                        />
                    </div>
                </Col>
                <Col className="col-12 col-md-6">

                    <div className="pt-1 account-type">
                        <LabelField title={"Account type"} />
                        <Select
                            {...{
                                formik,
                                name: `tax_report.filter.account_type`,
                                mandatory: true,
                                checkValidation: false,
                            }}
                            isClearable={formik.values.tax_report?.filter?.account_type ?? false}
                            onInputChange={(text) => searchAction(text)}
                            classNamePrefix="react-select"
                            options={accountTypeOptions}
                            isLoading={loading}
                            styles={colourStyles}
                            onChange={(value) => {
                                if (!value) {
                                    formik.setFieldValue("tax_report.filter.account_type", undefined)
                                    return;
                                }
                                formik.setFieldValue("tax_report.filter.account_type", value.value);
                                formik.setFieldValue("account_sub_type", {
                                    id: "",
                                    name: "",
                                });
                            }}
                            value={accountTypeOptions.find((item) => item.value === formik.values.tax_report?.filter?.account_type)}
                            components={{ DropdownIndicator }}

                        />

                        {formik.values.tax_report?.filter?.account_type === "" && valueCheck && (
                            <p className="text-red" style={{ marginBottom: "1em" }}>
                                Required!
                            </p>
                        )}
                    </div>
                </Col>
                <Col className="col-12 col-md-6">
                    <div className="pt-1 account-subtype-field">
                        <LabelField title={"Account Category"} />
                        <Select
                            {...{
                                formik,
                                name: `account_sub_type`,
                                mandatory: true,
                                checkValidation: false,
                            }}
                            isClearable={formik.values?.account_sub_type?.id ?? false}
                            onInputChange={(text) => searchAction(text)}
                            classNamePrefix="react-select"
                            formatOptionLabel={formatOptionLabel}
                            options={accountCategoryOptions}
                            isLoading={loading}
                            styles={colourStyles}
                            onChange={(value) => {
                                if (!value) {
                                    formik.setFieldValue(`account_sub_type`, undefined)
                                    formik.setFieldValue(`tax_report.filter.category`, undefined)
                                    return;
                                }
                                formik.setFieldValue(`account_sub_type`, {
                                    id: value.value,
                                    name: value.label,
                                });
                                formik.setFieldValue(`tax_report.filter.category`, value.label);
                            }}
                            value={{
                                label: formik.values?.account_sub_type?.name,
                                value: formik.values?.account_sub_type?.id,
                            }}
                            components={{ DropdownIndicator }}
                        // style={{ backgroundColor: "#FFFFFF", border: "1px solid #ebedf3" }}

                        />
                        {!formik?.values?.["account_sub_type"]?.id &&
                            !formik?.values?.["billing_type"]?.name &&
                            formik?.touched?.["account_sub_type"] &&
                            formik?.errors?.["account_sub_type"] ? (
                            <HintField error={formik?.errors?.["account_sub_type"]?.value} />
                        ) : null}
                    </div>
                </Col>
                <Col className="mt-7 col-12 col-md-6">
                    <div className=" billing-type-field">
                        <LabelField title={"Billing type"} />
                        <Select
                            {...{
                                formik,
                                name: `billing_type`,
                                mandatory: true,
                                checkValidation: false,
                            }}
                            isClearable={formik.values?.billing_type?.id ?? false}
                            onInputChange={(text) => searchAction(text)}
                            classNamePrefix="react-select"
                            formatOptionLabel={formatOptionLabel}
                            options={billingTypeOptions}
                            isLoading={loading}
                            styles={colourStyles}
                            onChange={(value) => {
                                if (!value) {
                                    formik.setFieldValue(`billing_type`, undefined)
                                    formik.setFieldValue(`tax_report.filter.billing_type`, undefined)
                                    return;
                                }
                                formik.setFieldValue(`billing_type`, {
                                    id: value.value,
                                    name: value.label,
                                });
                                formik.setFieldValue(`tax_report.filter.billing_type`, value.label);
                            }}
                            value={{
                                label: formik.values?.billing_type?.name,
                                value: formik.values?.billing_type?.id,
                            }}
                            components={{ DropdownIndicator }}
                        />
                        {!formik?.values?.["billing_type"]?.id &&
                            !formik?.values?.["billing_type"]?.name &&
                            formik?.touched?.["billing_type"] &&
                            formik?.errors?.["billing_type"] ? (
                            <HintField error={formik?.errors?.["taxReport.filter.billing_type"]?.value} />
                        ) : null}
                    </div>
                </Col>
                <Col className="mt-7 col-12 col-md-6">
                    <LabelField title={"Year selection"} mandatory={true} />
                    <div className="date-wrapper docu-date year-selection">
                        <DatePicker
                            mandatory
                            selected={year}
                            onChange={(date) => handleYear(date)}
                            showYearPicker
                            dateFormat="yyyy"
                            minDate={new Date().setFullYear(new Date().getFullYear() - 11)}
                            maxDate={new Date()}

                        />
                    </div>
                </Col>
                <Col className="col-12 col-md-6">
                    <div className="mt-7">
                        <LabelField title={"Exclude transactions from selected ledgers"} mandatory={false} />
                        <MenuMultiCheckBox
                            Items={ledgers}
                            formik={formik}
                            loading={isLedgerLoading}
                            isLedger={true}
                            withBorder={true}
                            field="all_ledger_sub_data"
                            styles={{
                                width: '100%',
                                '&& fieldset': {
                                    width: '100%',
                                },
                            }}
                        />
                    </div>
                </Col>
                <Col className="col-12 col-md-6"></Col>
                <Col className="col-12 col-md-6">
                    <Label>Account Tags</Label>
                    <Select
                        {...{
                            formik,
                            name: `accountTags`,
                            mandatory: true,
                            checkValidation: false,
                        }}
                        classNamePrefix="react-select"
                        options={accountTags}
                        valueKey="id"
                        labelKey="title"
                        isMulti
                        isLoading={accountTagsLoading}
                        styles={colourStyles}
                        onChange={(value) => {
                            formik.setFieldValue(`tax_report.filter.accountTags`, value);
                        }}
                        value={formik.values?.tax_report?.filter?.accountTags}
                        components={{ DropdownIndicator }}
                    />
                </Col>
                <Col className="col-12 col-md-6">
                    <Label>Contact Tags</Label>
                    <Select
                        {...{
                            formik,
                            name: `contactTags`,
                            mandatory: true,
                            checkValidation: false,
                        }}
                        classNamePrefix="react-select"
                        options={contactTags}
                        valueKey="id"
                        labelKey="title"
                        isMulti
                        isLoading={contactTagsLoading}
                        styles={colourStyles}
                        onChange={(value) => {
                            formik.setFieldValue(`tax_report.filter.contactTags`, value);
                        }}
                        value={formik.values?.tax_report?.filter?.contactTags}
                        components={{ DropdownIndicator }}
                    />
                </Col>
                <Col className="col-12 col-md-6 ">
                    <div
                        className="w-50"
                        style={{
                            marginTop: "3rem",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <MyCheckbox
                            title="Delete existing document"
                            checked={formik.values.tax_report?.deleteOldDocument}
                            onChange={() => formik.setFieldValue('tax_report.deleteOldDocument', !formik.values.tax_report?.deleteOldDocument)}
                        />
                        <InfoTooltip text="Replace any tax report previously generated for the same accounts and date range, instead of creating a duplicate." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                    </div>
                </Col>
                <Col className="col-12 col-md-6">
                    <div
                        className="w-50"
                        style={{
                            marginTop: "3rem",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <MyCheckbox
                            title="Don’t create for account with no  transactions"
                            checked={formik.values.tax_report?.deleteNoTransaction}
                            onChange={() => formik.setFieldValue('tax_report.deleteNoTransaction', !formik.values.tax_report?.deleteNoTransaction)}
                        />
                        <InfoTooltip text="Skip generating a tax report for any account that has no matching transactions, instead of creating an empty document." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                    </div>
                </Col>
                <Col className="col-12 col-md-6">
                    <div
                        className="w-50 mt-5"
                        style={{ display: "flex", alignItems: "center" }}
                    >
                        <MyCheckbox
                            title="Recalculate tax details using updated ledger data"
                            checked={formik.values.tax_report?.taxOverride}
                            onChange={() => formik.setFieldValue('tax_report.taxOverride', !formik.values.tax_report?.taxOverride)}
                        />
                        <InfoTooltip text="Recompute each account's tax-deductible totals from the latest ledger data instead of using previously saved values." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                    </div>
                </Col>
                <Col className="col-12 col-md-12">
                    <div>

                        <div
                            className="w-50 mt-5"
                        >
                            <MyCheckbox
                                title="Add note"
                                checked={formik.values.tax_report?.addNote}
                                onChange={(e) => {
                                    const { checked } = e.target;
                                    formik.setFieldValue('tax_report.addNote', checked);
                                }}
                            />
                        </div>
                        {formik.values.tax_report?.addNote && (
                            <div
                                className="mt-5"
                            >
                                <LabelField
                                    title={"Note"}
                                    mandatory={true}
                                />
                                <TextAreaMessage
                                    aria-label="empty textarea"
                                    minRows={12}
                                    placeholder="Note"
                                    value={formik.values.tax_report?.note}
                                    onChange={(e) => {
                                        formik.setFieldValue('tax_report.note', e.target.value);
                                    }}
                                />
                            </div>
                        )}
                    </div>

                </Col>
            </Row >
        </>
    );
};
